<script>
import { Line } from 'vue-chartjs'

export default {
  name: 'line-chart',
  extends: Line,
  props: ['chartdata', 'options'],
  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/pages/customerDashboard/LineChart.vue